import * as mqtt from "precompiled-mqtt";
import { IConnectionSetting, IPLCEvent } from "./EventReportInterfaces";
import { MQTTEventsEnum } from "constants/constants";

const { connect } = mqtt;

const connectionsSettings = {
    protocol: "ws" as "ws",
    clientId: "osorno_poc_client_test",
    username: process.env.REACT_APP_MOSQUITTO_BROKER_USER,
    password: process.env.REACT_APP_MOSQUITTO_BROKER_PASSWORD,
};

const defaultMQTTBrokerSettings: IConnectionSetting = {
    allow_anonymous: false,
    host: process.env.REACT_APP_MOSQUITTO_BROKER_URL || "mqtt://test.mosquitto.org:8081",
    user: process.env.REACT_APP_MOSQUITTO_BROKER_USER,
    password: process.env.REACT_APP_MOSQUITTO_BROKER_PASSWORD,
};

const plc_topic = process.env.REACT_APP_HMI_PLC_TOPIC || "topic/plc";

export const EventListeningEntity = {
    startListening: (
        onMessage: (message: IPLCEvent) => void,
        onError: (err: Error) => void,
        plcAddress: string[],
        options?: IConnectionSetting,
        clientId?: string,
    ): Promise<mqtt.MqttClient> => {
        return new Promise((res, rej) => {
            if (!options) {
                options = defaultMQTTBrokerSettings;
            }
            const mosquittoUrl = options.host;
            const isWSS = mosquittoUrl.startsWith("wss");
            const client = connect(mosquittoUrl, {
                ...connectionsSettings,
                username: options.user,
                password: options.password,
                protocol: isWSS ? "wss" : "ws",
                clientId,
                clean: true,
                reconnectPeriod: 10000,
            });

            let isListening = false;

            client.on(MQTTEventsEnum.ERROR, (err) => {
                client.end();
                isListening ? onError(err) : rej(err);
            });
            let connectHandled = false;
            client.on(MQTTEventsEnum.CONNECT, () => {
                if (connectHandled) {
                    return;
                }
                connectHandled = true;
                client.subscribe(
                    plcAddress.map((address) => `${plc_topic}${address ? `/${address}` : ""}`),
                    { qos: 0 },
                    (err) => {
                        if (err) {
                            rej(err);
                            client.end();
                            return;
                        }
                        isListening = true;
                        res(client);
                    },
                );
            });

            client.on(MQTTEventsEnum.MESSAGE, (_topic, message) => {
                onMessage(JSON.parse(message.toString()));
            });
        });
    },
};
